<template>
<div class="animated fadeIn mt-5">
  <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event,false)" v-if="dataLoaded">
    <div class="row">
      <div class="col-md-6">
        <b-card>
          <div slot="header">
            <strong>Ano de Actividade</strong>
          </div>
          <b-form-fieldset label="Actividade">
            <b-form-select v-model="item.activity_id" class="mb-3" :options="activities">
            </b-form-select>
          </b-form-fieldset>
          <b-form-fieldset label="Ano">
            <b-form-input type="text" name="activity_year" v-model="item.activity_year" placeholder="Ano" v-validate="{ required: true }" :state="validateState('activity_year')" data-vv-validate-on="change" ></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('activity_year') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>
          <b-row>
            <b-col md="4">
              <b-form-fieldset label="Estado">
                <b-form-select v-model="item.state" class="mb-3" :options="states.states">
                </b-form-select>
              </b-form-fieldset>
            </b-col>
            <b-col md="4">
              <b-form-fieldset label="Abertura">
                <b-form-input type="text" name="registrations_open" v-model="item.registrations_open" placeholder="Abertura" v-validate="{ required: true }" :state="validateState('registrations_open')" data-vv-validate-on="change" ></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('registrations_open') }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
            </b-col>
            <b-col md="4">
              <b-form-fieldset label="Fecho">
                <b-form-input type="text" name="registrations_close" v-model="item.registrations_close" placeholder="Fecho" v-validate="{ required: true }" :state="validateState('registrations_close')" data-vv-validate-on="change" ></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('registrations_close') }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
            </b-col>
          </b-row>


          <div slot="footer">
            <div class="row">
              <div class="col-sm-3">
                <router-link :to="{name: 'activities.edit', params: { id: item.activity_id} }" size="sm" variant="danger"><i class="fa fa-ban"></i> Cancelar</router-link>

              </div>
              <div class="col-sm-9 text-right">
                <b-button type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar</b-button>
                <b-button type="button" v-on:click="validateBeforeSubmit($event,true)" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar e fechar</b-button>
              </div>
            </div>
          </div>
        </b-card>
      </div>
      <div class="col-md-6">
        <b-card>
          <div slot="header">
            <strong>Definições</strong>
          </div>
          <b-row>
            <b-col md="4">
              <b-form-fieldset label="Preço">
                <b-form-input type="text" name="price" v-model="item.settings.price" placeholder="Preço" v-validate="{ required: true }" :state="validateState('price')" data-vv-validate-on="change" ></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('price') }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
            </b-col>

          </b-row>
          <b-row>
            <b-col md="4">
              <b-form-fieldset label="Dias para pagamento">
                <b-form-input type="text" name="payment_limits.days" v-model="item.settings.payment_limits.days" placeholder="Dias para pagamento" v-validate="{ required: true }" :state="validateState('payment_limits.days')" data-vv-validate-on="change" ></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('payment_limits.days') }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
            </b-col>
            <b-col md="4">
              <b-form-fieldset label="Data inicial de pagamento">
                <b-form-input type="text" name="payment_limits.min" v-model="item.settings.payment_limits.min" placeholder="Data inicial de pagamento" v-validate="{ required: true }" :state="validateState('payment_limits.min')" data-vv-validate-on="change" ></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('payment_limits.min') }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
            </b-col>
            <b-col md="4">
              <b-form-fieldset label="Data final de pagamento">
                <b-form-input type="text" name="payment_limits.max" v-model="item.settings.payment_limits.max" placeholder="Data final de pagamento" v-validate="{ required: true }" :state="validateState('payment_limits.max')" data-vv-validate-on="change" ></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('payment_limits.max') }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
            </b-col>

          </b-row>

        </b-card>
      </div>
      <!--/.col-->
    </div>
  </form>

</div>
</template>

<script>
import States from '@/components/Lists.js'
export default {
  name: 'ActivitiesEdit',
  props: ['id'],
  data() {
    return {
      url: 'activity_years',
      baseRoute: 'activity_years',
      dataLoaded: false,
      memberTypes: [],
      activities: [],
      states: States,
      item: {
        state: null,
        activity_id: null,
        activity_year: null,
        registrations_open: null,
        registrations_close: null,
        settings: {
          prices: 0,
          payment_limits: {
            max: null,
            min: null,
            days: 7
          }
        }
      }
    }
  },
  methods: {
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$bvToast.toast('Tem campos inválidos', { autoHideDelay: 5000, variant: 'danger', solid: true})
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {
      e.preventDefault()
      var data = {
        data: this.item
      }
      if (this.item.id) {
        this.axios.put(this.url + '/' + this.item.id, data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast('item gravado com sucesso', { autoHideDelay: 5000, variant: 'success', solid: true})
            if (close) {
              this.$router.push({
                name: this.baseRoute + '.index'
              })
            }
          })
          .catch(response => {
            this.$bvToast.toast('Não foi possivel gravar', { autoHideDelay: 5000, variant: 'danger', solid: true})
          })
      } else {
        this.axios.post(this.url, data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast('item gravado com sucesso', { autoHideDelay: 5000, variant: 'success', solid: true})
            this.$router.push({
              name: this.baseRoute + '.edit',
              params: {
                id: this.item.id
              }
            })
          })
          .catch(response => {
            this.$bvToast.toast('Não foi possivel gravar', { autoHideDelay: 5000, variant: 'danger', solid: true})
          })
      }
    }
  },
  created() {
    var id = this.$route.params.id
    if (typeof id !== 'undefined') {
      this.axios.get(this.url + '/' + id)
        .then(response => {
          this.item = response.data.data
          if(!this.item.settings) {
            this.item.settings = {
              prices: 0,
              payment_limits: {
                max: null,
                min: null,
                days: 7
              }
            }

          }
          this.dataLoaded = true
        })
        .catch(response => {
          this.$bvToast.toast('Esta actividade não existe', { autoHideDelay: 5000, variant: 'danger', solid: true})
          this.$router.push({
            name: this.baseRoute + '.index'
          })
        })
    } else {
      var activity_id = this.$route.params.activity_id
      this.item.activity_id = activity_id
      this.dataLoaded = true
    }
    this.axios.get('activities/lst').then(response => {
      this.activities = response.data.data
    })
  }
}
</script>
